<template>
  <textarea
    v-if="multiline"
    class="autoresize"
    @input="set"
    v-ok:enter
    ref="main"
    :value="value"
    :disabled="disabled"
    data-focus="1"
  />
  <input
    v-else
    type="text"
    @input="set"
    v-ok:enter
    ref="main"
    :value="value"
    :disabled="disabled"
    data-focus="1"
  />
</template>

<script>

export default {
	name:  "DVfieldString",
	props: {
		label:    {
			type:    String,
			default: "",
		},
		disabled: {
			type:    Boolean,
			default: false,
		},
		value:  {
			type:    String,
			default: false,
		},
    multiline: {
		  type: Boolean,
      default: false
    }
	},

  autoresize( o ) {
		o.style.boxSizing = "border-box";
		o.style.overflow = "hidden";
		o.style.resize = "none";
		o.style.transition = "none";
		o.wrap = "off";

		const style = window.getComputedStyle( o );
		const add = style.boxSizing === "border-box" ? parseInt( style.borderTopWidth, 10 ) + parseInt( style.borderBottomWidth, 10 ) : 0;

		const resize = () => {
			o.style.height = "";
			o.style.height = ( o.scrollHeight + add ) + "px";
		};

		resize();

		o.addEventListener( "input", resize );
  },

	data() {
		return {
		};
	},
	mounted() {
    if ( this.multiline ) {
      this.$options.autoresize( this.$refs.main );
    }
	},
	methods: {
		set( event ) {
			this.$emit( "input", this.$refs.main.value )
		}
	}
};
</script>

<style scoped>
*[data-focus] {
  border-radius: 0.2em;
  border: 0;
  display: block;
  box-shadow: inset 0 0 3px #000000;
  padding: 0.2em 0.5em;
  font: inherit;
  box-sizing: border-box;
  width: 100%;
}

.autoresize {
  display: block;
  resize: none;
  overflow: hidden;
  outline: none;
  white-space: pre;
  overflow-wrap: normal;
  height: 1.4em;
}
</style>